import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeDatatable()
    document.addEventListener("turbo:before-cache", this.destroyDatatable.bind(this))
  }

  disconnect() {
    this.destroyDatatable()
    document.removeEventListener("turbo:before-cache", this.destroyDatatable.bind(this))
  }

  initializeDatatable() {
    const dt_basic_table = $(this.element.querySelector('.datatables-basic'))

    // Check if DataTables is already initialized and destroy if yes
    if ($.fn.DataTable.isDataTable(dt_basic_table)) {
      dt_basic_table.DataTable().destroy()
    }

    dt_basic_table.DataTable({
      // order: [[0, 'asc']],
      "aaSorting": [],
      dom: '<"row"<"col-md-6"><"col-md-6"f>>rt<"row"<"col-md-12"p>>',
      displayLength: 40,
      lengthMenu: [25, 50, 75, 100],
      responsive: {
        details: {
          display: $.fn.dataTable.Responsive.display.modal({
            header: function(row) {
              var data = row.data();
              return 'Details of ' + data['full_name'];
            }
          }),
          type: 'column',
          renderer: function(api, rowIdx, columns) {
            var data = $.map(columns, function(col, i) {
              return col.title !== '' // ? Do not show row in modal popup if title is blank (for check box)
                ? '<tr data-dt-row="' +
                col.rowIdx +
                '" data-dt-column="' +
                col.columnIndex +
                '">' +
                '<td>' +
                col.title +
                ':' +
                '</td> ' +
                '<td>' +
                col.data +
                '</td>' +
                '</tr>'
                : '';
            }).join('');
            return data ? $('<table class="table"/>').append('<tbody>' + data + '</tbody>') : false;
          }
        }
      },
      ...window.datatablesDefaults,
      language: {
        searchPlaceholder: "Rechercher un élève",
      }
    });
  }

  destroyDatatable() {
    const dt_basic_table = $(this.element.querySelector('.datatables-basic'))
    if ($.fn.DataTable.isDataTable(dt_basic_table)) {
      dt_basic_table.DataTable().destroy()
    }
  }
}
